import { apiRequest } from './_tools';

export function fetchAllCountryLanguages() {
  return apiRequest('/api/countryLanguagesAndCountries')
    .catch(({ error }) => Promise.reject(error));
}
